var _path, _g, _g2, _g3, _path2, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisapointface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8132_61656)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8132_61656",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H0V14H14V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8132_61656)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_8132_61656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.54472C0 2.93017 2.93017 0 6.54472 0H7.22764C10.9679 0 14 3.03209 14 6.77236V7.22764C14 10.9679 10.9679 14 7.22764 14H7C3.13401 14 0 10.866 0 7V6.54472Z",
    fill: "url(#paint0_radial_8132_61656)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8132_61656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77896 6.03906C6.01343 6.03906 6.20812 6.23131 6.15781 6.46031C6.07797 6.8238 5.89568 7.16014 5.62844 7.4274C5.26023 7.79561 4.76083 8.00248 4.2401 8.00248C3.71937 8.00248 3.21997 7.79561 2.85175 7.4274C2.59828 7.17392 2.42127 6.85829 2.33556 6.51631C2.27085 6.25805 2.49251 6.03906 2.75875 6.03906C3.00835 6.03906 3.20223 6.25071 3.30832 6.47665C3.35849 6.58347 3.42713 6.68192 3.5122 6.76695C3.70525 6.95999 3.96708 7.06846 4.2401 7.06846C4.51312 7.06846 4.77495 6.95999 4.968 6.76695C5.03925 6.6957 5.09898 6.61511 5.14599 6.52798C5.27962 6.28036 5.4976 6.03906 5.77896 6.03906Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77896 6.03906C6.01343 6.03906 6.20812 6.23131 6.15781 6.46031C6.07797 6.8238 5.89568 7.16014 5.62844 7.4274C5.26023 7.79561 4.76083 8.00248 4.2401 8.00248C3.71937 8.00248 3.21997 7.79561 2.85175 7.4274C2.59828 7.17392 2.42127 6.85829 2.33556 6.51631C2.27085 6.25805 2.49251 6.03906 2.75875 6.03906C3.00835 6.03906 3.20223 6.25071 3.30832 6.47665C3.35849 6.58347 3.42713 6.68192 3.5122 6.76695C3.70525 6.95999 3.96708 7.06846 4.2401 7.06846C4.51312 7.06846 4.77495 6.95999 4.968 6.76695C5.03925 6.6957 5.09898 6.61511 5.14599 6.52798C5.27962 6.28036 5.4976 6.03906 5.77896 6.03906Z",
    fill: "#221725"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8132_61656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2985 6.03906C11.533 6.03906 11.7276 6.23131 11.6773 6.46031C11.5975 6.8238 11.4152 7.16014 11.148 7.4274C10.7797 7.79561 10.2804 8.00248 9.75962 8.00248C9.23889 8.00248 8.7395 7.79561 8.37129 7.4274C8.11781 7.17392 7.94082 6.85829 7.85511 6.51631C7.79035 6.25805 8.01201 6.03906 8.2783 6.03906C8.52785 6.03906 8.72174 6.25071 8.82783 6.47665C8.87802 6.58347 8.94665 6.68192 9.03174 6.76695C9.22478 6.95999 9.48662 7.06846 9.75962 7.06846C10.0326 7.06846 10.2945 6.95999 10.4875 6.76695C10.5588 6.6957 10.6185 6.61511 10.6655 6.52798C10.7991 6.28036 11.0171 6.03906 11.2985 6.03906Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2985 6.03906C11.533 6.03906 11.7276 6.23131 11.6773 6.46031C11.5975 6.8238 11.4152 7.16014 11.148 7.4274C10.7797 7.79561 10.2804 8.00248 9.75962 8.00248C9.23889 8.00248 8.7395 7.79561 8.37129 7.4274C8.11781 7.17392 7.94082 6.85829 7.85511 6.51631C7.79035 6.25805 8.01201 6.03906 8.2783 6.03906C8.52785 6.03906 8.72174 6.25071 8.82783 6.47665C8.87802 6.58347 8.94665 6.68192 9.03174 6.76695C9.22478 6.95999 9.48662 7.06846 9.75962 7.06846C10.0326 7.06846 10.2945 6.95999 10.4875 6.76695C10.5588 6.6957 10.6185 6.61511 10.6655 6.52798C10.7991 6.28036 11.0171 6.03906 11.2985 6.03906Z",
    fill: "#221725"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddii_8132_61656)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8132_61656",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 6,
    height: 3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35624 10.7791C4.12484 10.6326 4.0629 10.3189 4.2533 10.122C4.53007 9.83577 4.8571 9.59447 5.22137 9.40906C5.73995 9.14511 6.31868 9.00226 6.90861 8.9927C7.49849 8.98314 8.08217 9.10709 8.61018 9.35403C8.98152 9.52772 9.31764 9.75866 9.60498 10.0361C9.80183 10.2262 9.75084 10.5415 9.52473 10.6956C9.3173 10.8369 9.03832 10.7885 8.85273 10.6194C8.65406 10.4384 8.42613 10.2865 8.17652 10.1697C7.78834 9.98818 7.35917 9.89701 6.9254 9.90407C6.49169 9.91112 6.06616 10.0161 5.68486 10.2102C5.44053 10.3345 5.21899 10.4931 5.0275 10.6798C4.84715 10.8556 4.56901 10.9138 4.35624 10.7791Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8132_61656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35624 10.7791C4.12484 10.6326 4.0629 10.3189 4.2533 10.122C4.53007 9.83577 4.8571 9.59447 5.22137 9.40906C5.73995 9.14511 6.31868 9.00226 6.90861 8.9927C7.49849 8.98314 8.08217 9.10709 8.61018 9.35403C8.98152 9.52772 9.31764 9.75866 9.60498 10.0361C9.80183 10.2262 9.75084 10.5415 9.52473 10.6956C9.3173 10.8369 9.03832 10.7885 8.85273 10.6194C8.65406 10.4384 8.42613 10.2865 8.17652 10.1697C7.78834 9.98818 7.35917 9.89701 6.9254 9.90407C6.49169 9.91112 6.06616 10.0161 5.68486 10.2102C5.44053 10.3345 5.21899 10.4931 5.0275 10.6798C4.84715 10.8556 4.56901 10.9138 4.35624 10.7791Z",
    stroke: "url(#paint1_linear_8132_61656)",
    strokeWidth: 1.25203,
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_8132_61656",
    x: -1.53659,
    y: -1.36585,
    width: 19.4634,
    height: 22.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.19512,
    dy: 4.15447
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36585
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8132_61656",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.36585
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.882114
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.626016,
    dy: 1.70732
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.882114
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.766722 0 0 0 0 0.693056 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_8132_61656",
    result: "effect3_innerShadow_8132_61656"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8132_61656",
    x: 1.66975,
    y: 4.46264,
    width: 6.19789,
    height: 4.32094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.523577,
    dy: -0.398374
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.589024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8132_61656",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8132_61656",
    x: 7.18928,
    y: 4.34882,
    width: 6.19789,
    height: 4.32094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.523577,
    dy: -0.512195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.589024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8132_61656",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddii_8132_61656",
    x: 2.2436,
    y: 7.30194,
    width: 9.38096,
    height: 6.39515,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.948511
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948511
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0298758 0 0 0 0 0.0216858 0 0 0 0 0.0308333 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.523577,
    dy: -0.512195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.589024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8132_61656",
    result: "effect2_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.523577,
    dy: -0.512195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.589024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_8132_61656",
    result: "effect3_dropShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_8132_61656",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.295092
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.147546
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17328 0 0 0 0 0.125777 0 0 0 0 0.178833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_8132_61656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.147546
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0737732
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119503 0 0 0 0 0.086743 0 0 0 0 0.123333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_8132_61656",
    result: "effect5_innerShadow_8132_61656"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8132_61656",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.20325 0.910569) rotate(86.5167) scale(13.1137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8132_61656",
    x1: 6.97212,
    y1: 15.8784,
    x2: 6.97212,
    y2: 8.99219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1F2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8132_61656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisapointface);
export default __webpack_public_path__ + "static/media/disapointface.d18e8f07e0f2adba1efc699acddda4d4.svg";
export { ForwardRef as ReactComponent };